import { render, staticRenderFns } from "./AsideBarCreateRisk.vue?vue&type=template&id=28b663ed&scoped=true"
import script from "./AsideBarCreateRisk.vue?vue&type=script&lang=js"
export * from "./AsideBarCreateRisk.vue?vue&type=script&lang=js"
import style0 from "./AsideBarCreateRisk.vue?vue&type=style&index=0&id=28b663ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b663ed",
  null
  
)

export default component.exports